import React, {Fragment} from 'react';

class AppFooter extends React.Component {
    render() {


        return (
            <Fragment>
                <div className="app-footer">
                    <div  className="app-footer__inner">
                    <span className='text-center'>Powered by Walkins. © 2022, All Rights Reserved. Design & Developed by LoMoSo Solutions Pvt Limited</span>
                    </div>
                 </div>
            </Fragment>
        )}
}

export default AppFooter;